import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { fetchRecommendations } from 'Redux/ducks/recommendations';
import HitCard from 'Components/Cards/HitCard';
import PriceContainer from 'Containers/Utility/Price/PriceContainer';
import store from 'Redux/store';

const RecommendedProducts = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    store.dispatch(fetchRecommendations('cart', null, [], null)).then((results) => {
      setProducts(results);
    });
  }, []);

  return (
    <article className="account-table">
      <h2 className="account-table-heading">
        <FormattedMessage id="recommended-products.table.title" defaultMessage="Recommended Products" />
      </h2>
      <div className="account-table-row recommended-products">
        <div className="row">
          {products.slice(0, 4).map(hit =>
            <HitCard
              key={hit.objectID}
              hit={hit}
              xsSize={12}
              smSize={6}
              mdSize={4}
              lgSize={4}
            >
              <PriceContainer
                discountPercent={hit.discount_percent}
                price={hit.price}
                tiered={hit.tiered}
                slug={hit.slug}
                hideDiscount={hit.hide_discount}
                payWhatYouWant={hit.pay_what_you_want}
              />
            </HitCard>,
          )}
        </div>
      </div>
    </article>
  );
};

export default RecommendedProducts;
